import "../homeStyles.css";

export const BigPicture = () => {
  return (
    <div className="relative">
      {/* <picture className="opacity-90"> */}
      <picture className="brightness-90">
        {/* <source
          media="(min-width: 900px)"
          srcSet="/photos/home/to_left_side_picture/to_left_side_picture.jpg"
        /> */}
        <source
          media="(min-width: 700px)"
          srcSet="/photos/home/main_big_picture/main_big_picture.jpg"
        />
        <img
          className="max-h-screen w-full bg-cover bg-center bg-no-repeat"
          src={"/photos/home/main_big_picture/main_big_picture.jpg"}
          alt="logo"
          loading="eager"
        />
      </picture>
      <div className="absolute left-1/10 top-1/3 p-2 md:left-1/4 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2">
        <span className="block text-4xl md:text-6xl">This is Džiugas </span>
        <span className="mt-5 block text-xl">Model / Artist</span>
      </div>
    </div>
  );
};
